// This for flight seat selection, it is sensitive information for seat selection, so do not touch
const Description = Object.freeze({
  0: "NotSet",
  1: "Included",
  2: "Direct",
  3: "Imported",
  4: "UpGrade",
  5: "ImportedUpgrade",
})

const WayType = Object.freeze({
  0: "NotSet",
  1: "Segment",
  2: "FullJourney",
})

const SeatAvailalblityType = Object.freeze({
  0: "Notset",
  1: "Open",
  2: "CheckedIn",
  3: "Reserved",
  4: "Blocked",
  5: "NoSeatAtThisLocation",
})

const SeatDescriptor = Object.freeze({
  0: "NotSet",
  1: "Included",
  2: "Purchase",
  3: "UpGrade",
})

const SeatType = Object.freeze({
  0: "NotSet",
  1: "Window",
  2: "Aisle",
  3: "Middle",
  4: "WindowRecline",
  5: "WindowWing",
  6: "WindowExitRow",
  7: "WindowReclineWing",
  8: "WindowReclineExitRow",
  9: "WindowWingExitRow",
  10: "AisleRecline",
  11: "AisleWing",
  12: "AisleExitRow",
  13: "AisleReclineWing",
  14: "AisleReclineExitRow",
  15: "AisleWingExitRow",
  16: "MiddleRecline",
  17: "MiddleWing",
  18: "MiddleExitRow",
  19: "MiddleReclineWing",
  20: "MiddleReclineExitRow",
  21: "MiddleWingExitRow",
  22: "WindowReclineWingExitRow",
  23: "AisleReclineWingExitRow",
  24: "MiddleReclineWingExitRow",
  25: "WindowBulkhead",
  26: "WindowQuiet",
  27: "WindowBulkheadQuiet",
  28: "MiddleBulkhead",
  29: "MiddleQuiet",
  30: "MiddleBulkheadQuiet",
  31: "AisleBulkhead",
  32: "AisleQuiet",
  33: "AisleBulkheadQuiet",
  34: "CentreAisle",
  35: "CentreMiddle",
  36: "CentreAisleBulkhead",
  37: "CentreAisleQuiet",
  38: "CentreAisleBulkheadQuiet",
  39: "CentreMiddleBulkhead",
  40: "CentreMiddleQuiet",
  41: "CentreMiddleBulkheadQuiet",
  42: "WindowBulkheadWing",
  43: "WindowBulkheadExitRow",
  44: "MiddleBulkheadWing",
  45: "MiddleBulkheadExitRow",
  46: "AisleBulkheadWing",
  47: "AisleBulkheadExitRow",
});

const Deck = Object.freeze({
  0: "NotSet",
  1: "Deck1",
  2: "Deck2",
  3: "Deck3",
})

const CompartmentType = Object.freeze({
  0: "NotSet",
  1: "Compartment1",
  2: "Compartment2",
  3: "Compartment3",
  4: "Compartment4",
  5: "Compartment5",
  6: "Compartment6",
  7: "Compartment7",
})

const CabinType = Object.freeze({
  1: "All",
  2: "Economy",
  3: "PremiumEconomy",
  4: "Business",
  5: "PremiumBusiness",
  6: "First",
})

export const AirDataObjects:any = {
  Description, WayType, SeatAvailalblityType, SeatDescriptor, SeatType, Deck, CompartmentType, CabinType
}